
import { logger } from '@/utils/logger';
import { safeGetContent } from '@/utils/errorUtils';
import { getSecurityDemoContent, getPlaceholderContent } from '../demoContent/securityContent';
import { extractTextFromHtml } from '../extraction/htmlExtractor';
import { UniversalCrawlerService } from '@/services/universalCrawlerService';

/**
 * Core functionality for fetching article content from a URL using universal crawler
 */
export async function fetchContentFromUrl(url: string): Promise<string> {
  console.log(`🔍 FAQ Expert: Fetching content using universal crawler for URL: ${url}`);
  
  try {
    // Use the universal crawler service for all domains
    const result = await UniversalCrawlerService.fetchContent(url);
    
    if (result.success && result.content) {
      console.log(`✅ FAQ Expert: Successfully fetched real content (${result.content.length} chars) from ${url}`);
      console.log(`📝 FAQ Expert: Content preview: "${result.content.substring(0, 200)}..."`);
      
      if (result.content.length < 100) {
        console.warn('⚠️ FAQ Expert: Content too short, this will result in generic FAQs');
        throw new Error(`Content too short (${result.content.length} chars). Need at least 100 characters for meaningful FAQ generation.`);
      }
      
      return result.content;
    } else {
      console.error(`❌ FAQ Expert: Content fetch failed for ${url}: ${result.error}`);
      throw new Error(`Failed to fetch content from ${url}: ${result.error}`);
    }
  } catch (error) {
    console.error('💥 FAQ Expert: Error in universal content fetching:', error);
    logger.error('FAQ content fetch failed', error as Error, { 
      context: { url, component: 'faqContentFetcher' }
    });
    
    // Don't use fallback content - let the error bubble up so user knows what's happening
    throw new Error(`Unable to fetch content from ${url}. Please ensure the URL is accessible and contains sufficient content for FAQ generation.`);
  }
}
